const A = {
  ALA: {
    id: "ALA",
    name: "Al Ahly",
    slug: "al-ahly",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  INM: {
    id: "INM",
    name: "Inter Miami",
    slug: "inter-miami",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  PAL: {
    id: "PAL",
    name: "Palmeiras",
    slug: "palmeiras",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  POR: {
    id: "POR",
    name: "Porto",
    slug: "porto",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
};

const B = {
  BOT: {
    id: "BOT",
    name: "Botafogo",
    slug: "botafogo",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  ATM: {
    id: "ATM",
    name: "Atl. de Madrid",
    slug: "atletico-de-madrid",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  PSG: {
    id: "PSG",
    name: "PSG",
    slug: "psg",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  SSO: {
    id: "SSO",
    name: "Seattle Sounders",
    slug: "seattle-sounders",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
};

const C = {
  BAY: {
    id: "BAY",
    name: "Bayern Munich",
    slug: "bayern-munich",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  AUC: {
    id: "AUC",
    name: "Auckland City",
    slug: "auckland-city",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  BEN: {
    id: "BEN",
    name: "Benfica",
    slug: "benfica",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  BOC: {
    id: "BOC",
    name: "Boca Juniors",
    slug: "boca-juniors",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
};

const D = {
  LAN: {
    id: "LAN",
    name: "Los Angeles",
    slug: "los-angeles",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  CHE: {
    id: "CHE",
    name: "Chelsea",
    slug: "chelsea",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  ESP: {
    id: "ESP",
    name: "Espérance",
    slug: "esperance",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  FLA: {
    id: "FLA",
    name: "Flamengo",
    slug: "flamengo",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
};

const E = {
  MON: {
    id: "MON",
    name: "Monterrey",
    slug: "monterrey",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  INT: {
    id: "INT",
    name: "Inter",
    slug: "inter",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  RIV: {
    id: "RIV",
    name: "River Plate",
    slug: "river-plate",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  URR: {
    id: "URR",
    name: "Urawa Red",
    slug: "urawa-red",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
};

const F = {
  DOR: {
    id: "DOR",
    name: "Dortmund",
    slug: "dortmund",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  FLU: {
    id: "FLU",
    name: "Fluminense",
    slug: "fluminense",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  MML: {
    id: "MML",
    name: "Mamelodi",
    slug: "mamelodi",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  ULS: {
    id: "ULS",
    name: "Ulsan HD",
    slug: "ulsan",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
};

const G = {
  MCI: {
    id: "MCI",
    name: "Manchester City",
    slug: "manchester-city",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  ALN: {
    id: "ALN",
    name: "Al Ain",
    slug: "al-ain",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  JUV: {
    id: "JUV",
    name: "Juventus",
    slug: "juventus",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  WYD: {
    id: "WYD",
    name: "Wydad",
    slug: "wydad",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
};

const H = {
  ALH: {
    id: "ALH",
    name: "Al Hilal",
    slug: "al-hilal",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  PAC: {
    id: "PAC",
    name: "Pachuca",
    slug: "pachuca",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  REM: {
    id: "REM",
    name: "Real Madrid",
    slug: "real-madrid",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
  SAL: {
    id: "SAL",
    name: "Salzburg",
    slug: "salzburg",
    points: 0,
    playedMatches: 0,
    wonMatches: 0,
    drawnMatches: 0,
    lostMatches: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    goalsDifference: 0,
  },
};

export const teamsByGroup = { A, B, C, D, E, F, G, H };
